/**
 * Utilitário para geração de cores de avatar baseadas no nome
 * Similar ao padrão WhatsApp Business
 * 
 * Gera cores pastéis consistentes para cada contato baseado
 * no hash do nome/identificador
 * 
 * Versão: 1.0.0
 */

/**
 * Paleta de cores pastéis estilo WhatsApp Business
 * Cada cor tem variantes para light e dark mode
 */
const AVATAR_COLORS = [
  { bg: 'bg-rose-100 dark:bg-rose-900/30', text: 'text-rose-600 dark:text-rose-400' },
  { bg: 'bg-pink-100 dark:bg-pink-900/30', text: 'text-pink-600 dark:text-pink-400' },
  { bg: 'bg-orange-100 dark:bg-orange-900/30', text: 'text-orange-600 dark:text-orange-400' },
  { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-600 dark:text-amber-400' },
  { bg: 'bg-lime-100 dark:bg-lime-900/30', text: 'text-lime-600 dark:text-lime-400' },
  { bg: 'bg-green-100 dark:bg-green-900/30', text: 'text-green-600 dark:text-green-400' },
  { bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-600 dark:text-emerald-400' },
  { bg: 'bg-teal-100 dark:bg-teal-900/30', text: 'text-teal-600 dark:text-teal-400' },
  { bg: 'bg-cyan-100 dark:bg-cyan-900/30', text: 'text-cyan-600 dark:text-cyan-400' },
  { bg: 'bg-sky-100 dark:bg-sky-900/30', text: 'text-sky-600 dark:text-sky-400' },
  { bg: 'bg-blue-100 dark:bg-blue-900/30', text: 'text-blue-600 dark:text-blue-400' },
  { bg: 'bg-indigo-100 dark:bg-indigo-900/30', text: 'text-indigo-600 dark:text-indigo-400' },
  { bg: 'bg-violet-100 dark:bg-violet-900/30', text: 'text-violet-600 dark:text-violet-400' },
  { bg: 'bg-purple-100 dark:bg-purple-900/30', text: 'text-purple-600 dark:text-purple-400' },
];

/**
 * Gera classes CSS de cor para avatar baseado no nome/identificador
 * Usa hash do texto para garantir cor consistente para o mesmo nome
 * 
 * @param name - Nome ou identificador do contato
 * @returns String com classes Tailwind para bg e text
 */
export function getAvatarColorClasses(name: string | null | undefined): string {
  if (!name || name.trim() === '') {
    // Fallback para quando não há nome - cinza neutro
    return 'bg-muted text-muted-foreground';
  }
  
  // Gera hash simples a partir do nome para garantir consistência
  const hash = name
    .trim()
    .toLowerCase()
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  
  const color = AVATAR_COLORS[hash % AVATAR_COLORS.length];
  return `${color.bg} ${color.text}`;
}
